import Btn from './Btn';
import Tx from './Tx';
import { useState } from 'react';
import EdgeDialog from './dialogs/EdgeDialog';
import InstallerEdgeCard from './InstallerEdgeCard';
import StoresColumn from './StoresColumn';

export default function StoresEdges(props) {

    const { selectedClient, selectedSite, selectedEdge } = props;

    const [open_edge_dialog, s_open_edge_dialog] = useState(false);
    const [new_edge, s_new_edge] = useState(false);
    const [edit_item, s_edit_item] = useState({});

    return (
        <StoresColumn color="#fdd54640">
            {
                props.edges.map(edge => {
                    return (
                        <InstallerEdgeCard
                            selected={props.selectedEdge._id === edge._id}
                            key={edge._id}
                            selectedSiteType={selectedSite.siteType}
                            {...edge}
                            forceGetEdges={() => {
                                props.getEdges();
                            }}
                            onEdit={() => {
                                s_new_edge(false);
                                s_edit_item(edge);
                                s_open_edge_dialog(true);
                            }}
                            onClick={() => props.onSelected(edge)}
                        />
                    );
                })
            }
            <div><Btn startIcon="edge" onClick={() => {
                s_new_edge(true);
                s_edit_item({});
                s_open_edge_dialog(true);
            }}><Tx>g.add</Tx></Btn></div>
            {
                open_edge_dialog && <EdgeDialog edgeId={selectedEdge._id} siteId={selectedSite._id} clientId={selectedClient._id} open={open_edge_dialog} newEdge={new_edge} edge={edit_item} onClose={() => {
                    s_open_edge_dialog(false);
                    s_edit_item({});
                    props.getEdges();
                }} />
            }
        </StoresColumn>
    )
}
